/**
 * 独立与业务，功能演示
 */
export default {
    name: 'example',
    path: '/example',
    meta: {},
    component: () => import('@/views/example/Home'),
    redirect: '/example/index',
    children: [
        {
            //入口
            name: 'exampleIndex',
            path: 'index',
            meta: {},
            component: () => import('@/views/example/children/Index'),
        },
        {
            name: 'svgicon',
            path: 'svgicon',
            meta: {},
            component: () => import('@/views/example/children/Svgicon'),
        },
        {
            name: 'Test',
            path: 'test',
            meta: {},
            component: () => import('@/views/example/children/Test'),
        }, //VenusPre
        {
            name: 'VenusPre',
            path: 'venusPre',
            meta: {},
            component: () => import('@/views/example/children/VenusPre'),
        },
    ],
};
